import CircleIcon from '@mui/icons-material/Circle';
import { Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import moment from 'moment';
import React, { memo, useMemo } from 'react';
import theme from '../../../../../theme';
import { Dashboard, EmailBody } from '../../../../../types/files';
import ArrayUtils from '../../../../../utils/ArrayUtils';
import useStyles from "../styles";

const RecentCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const classes = useStyles();

    const emailItems: EmailBody[] = useMemo(() =>
        ArrayUtils.sortByDescending([...dashboard?.emailBodies
            ?.filter(emailBody => ['NEW_DEAL', 'COMPANY_UPDATE'].includes(emailBody?.contentClassification || '')) || []], 'createdAt')
    , [dashboard?.emailBodies]);

    return (<>
        {(emailItems?.[0]?.contentClassification === 'COMPANY_UPDATE') ? (
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" width="100%">
                <CircleIcon sx={{ width: 12, height: 12, fill: theme.colors.warning['400'] }} />
                <Typography className={classes.label}
                    fontWeight="600 !important"
                    color={`${theme.colors.neutral['700']} !important`}>
                    {'Company update'}
                </Typography>
                <Typography className={classnames(classes.label, classes.sublabel)}
                    color={`${theme.colors.neutral['600']} !important`}>
                    {moment(emailItems?.[0]?.createdAt).fromNow()}
                </Typography>
            </Stack>
        ) : (
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" width="100%">
                <CircleIcon sx={{ width: 12, height: 12, fill: theme.colors.blue['600'] }} />
                <Typography className={classes.label}
                    fontWeight="600 !important"
                    color={`${theme.colors.neutral['700']} !important`}>
                    {'New deal'}
                </Typography>
                <Typography className={classnames(classes.label, classes.sublabel)}
                    color={`${theme.colors.neutral['600']} !important`}>
                    {moment(dashboard.createdAt).fromNow()}
                </Typography>
            </Stack>
        )}
    </>);
}

export default memo(RecentCell);
